import { createContainer, createStore, type Action } from '@atlassian/react-sweet-state';
import type { ReorderRow } from '../../common/types.tsx';
import type { ContainerProps, State, DropTarget } from './types.tsx';

// Exported for testing
export const initialState: State = {
	currentDropTarget: null,
	instanceId: 'pdnd-issue-table-rows',
	onRowReorder: undefined,
};

const actions = {
	setDropTarget:
		(dropTarget: DropTarget | null): Action<State> =>
		({ setState }) => {
			setState({
				currentDropTarget: dropTarget,
			});
		},
	reorderRows:
		(payload: Parameters<ReorderRow>[0]): Action<State> =>
		({ getState }) => {
			const { onRowReorder } = getState();
			onRowReorder?.(payload);
		},
};

export const DraggableRowsContainer = createContainer<ContainerProps>();

export const Store = createStore({
	initialState,
	actions,
	containedBy: DraggableRowsContainer,
	handlers: {
		onInit:
			() =>
			({ setState }, { instanceId, onRowReorder }) => {
				setState({ instanceId: instanceId ?? initialState.instanceId, onRowReorder });
			},
		onContainerUpdate:
			(props, prevProps) =>
			({ setState }, { instanceId, onRowReorder }) => {
				if (props.instanceId !== prevProps.instanceId) {
					setState({ instanceId, onRowReorder });
				}
			},
	},
});
